import { render, staticRenderFns } from "./EventTypeList.vue?vue&type=template&id=f78b8ada&scoped=true"
import script from "./EventTypeList.vue?vue&type=script&lang=js"
export * from "./EventTypeList.vue?vue&type=script&lang=js"
import style0 from "./EventTypeList.vue?vue&type=style&index=0&id=f78b8ada&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f78b8ada",
  null
  
)

export default component.exports